/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import { useUIDSeed } from 'react-uid';
import { object, shape, string } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ReactHTMLParser from 'react-html-parser';
import { Link } from 'react-router-dom';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { useQuery } from '@apollo/client';
import GraphqlSeoHeadTags from '../../GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';
import findContent from '../../../../gql/queries/findContent';

const styles = (theme) => ({
    container: {
        [theme.breakpoints.down('sm')]: {
            maxWidth: theme.palette.tiers?.container?.maxWidth?.downSmall,
            margin: '0 auto',
        },
        [theme.breakpoints.down('md')]: {
            maxWidth: theme.palette.tiers?.container?.maxWidth?.downMedium,
            margin: '0 auto',
        },
        [theme.breakpoints.up('md')]: {
            maxWidth: 1440,
            margin: '0 auto',
        },
        [theme.breakpoints.up('lg')]: {
            maxWidth: 1024,
            margin: '0 auto',
            padding: '2%',
        },
        padding: 10,
        letterSpacing: '0.03em',
    },
    header: {
        margin: '32px auto',
        textAlign: 'center',
        fontSize: 25,
    },
    subHeader: {
        color: '#404040',
        fontSize: 15,
        fontWeight: 'bold',
    },
    description: {
        color: ' #404040',
        fontSize: 14,
        '& p': {
            margin: '4px 0 24px',
            lineHeight: 1.8,
            '& a': {
                color: '#65388b',
            },
        },
    },
    breadCrumb: {
        '& a': {
            color: ' #404040',
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
            fontSize: 15,
            outline: 'none',
        },
    },
    arrowSign: {
        fontSize: 16,
        verticalAlign: 'middle',
    },
});

const CustomerServiceFaqCovid = ({ brand, classes }) => {
    const seed = useUIDSeed();
    const CUSTOMER_SERVICE_COVID_QUERY = findContent({
        brand: brand?.domain || brand?.['domain-name'] || '1800flowers',
        contentType: 'customer_service_covid',
    });
    const { data, error, loading } = useQuery(CUSTOMER_SERVICE_COVID_QUERY);

    if (loading || error) {
        return null;
    }

    const contentData = data?.findContent?.content?.entries?.[0];
    if (!contentData) {
        return null;
    }

    const {
        list = [], header, title, seo, back_url: backUrl,
    } = contentData;
    const backUrlTitle = backUrl?.title || 'Help Center/ FAQ&#39;s';
    const backUrlHref = backUrl?.href || '/customer-service';
    const pageTitle = header || title;

    return (
        <>
            <GraphqlSeoHeadTags seoData={seo} />
            <div className={classes.container}>
                <div className={classes.breadCrumb}><Link to={backUrlHref}><ArrowBackIosIcon className={classes.arrowSign} />{ReactHTMLParser(backUrlTitle)}</Link></div>
                <h1 className={classes.header}>{pageTitle}</h1>
                {list.map((item) => (
                    <div
                        key={seed(item)}
                        className={classes.content}
                    >
                        <h2 className={classes.subHeader}> {ReactHTMLParser(item.subheader)}</h2>
                        <div className={classes.description}> {ReactHTMLParser(item.description)}</div>
                    </div>
                ))}

            </div>
        </>
    );
};

CustomerServiceFaqCovid.propTypes = {
    brand: shape({
        domain: string,
        'domain-name': string,
    }),
    classes: object.isRequired,
};

CustomerServiceFaqCovid.defaultProps = {
    brand: {},
};

export default withStyles(styles)(CustomerServiceFaqCovid);
